import { useCollectionStateContext } from 'Context/CollectionStateContext';
import DataContainer from 'Components/UI/DataContainer';
import React from 'react';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import {
  Layout,
} from './Layout';

const metaOverrideSet = buildFacetDesignOverride();

export const Container = () => {
  const {
    collection, isInitializing, loading, loadingError,
  } = useCollectionStateContext();

  return (
    <DataContainer
      component={MetaCollectionRenderer}
      componentProps={{
        collection,
        layout: Layout,
        metaOverrideSet,
      }}
      loading={loading || isInitializing}
      loadingError={loadingError}
    />
  );
};
